import { BlockComponent } from "../../framework/src/BlockComponent";
import {
  QuickBlox,
  QBUser,
  QBWebRTCSession,
} from "quickblox/quickblox";
import { Message } from "../../framework/src/Message";
import MessageEnum, { getName } from "../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../framework/src/RunEngine";
const configJSON = require("./config");

export type TabValue =
  | "dashboard"
  | "patient"
  | "task_list"
  | "visit_schedule"
  | "send_notification"
  | "messages"
  | "community";

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  selected?: TabValue
  language?: string
  // Customizable Area End
}
interface S {
  // Customizable Area Start
  selected: TabValue;
  showModal: boolean;
  isCalling: boolean;
  patientsIds: any;
  usersChatList: any;
  userIdDialog: string | undefined;
  userDetail: any;
  sessionState: any;
  isCommunityEnabled: any;  
  // Customizable Area End
}
interface SS {
  id: any;
}

class SidebarController extends BlockComponent<Props, S, SS> {
  QB = new QuickBlox();
  getStudyApiCallId: string | number | null = null;
  constructor(props: Props) {
    super(props);

    this.state = {
      selected: props.selected || "dashboard",
      showModal: false,
      isCalling: false,
      patientsIds: [],
      usersChatList: [],
      userIdDialog: "",
      userDetail: {},
      sessionState: {},
      isCommunityEnabled: localStorage.getItem("communityEnabled") === "true"
    };
    runEngine.attachBuildingBlock(this, [
      getName(MessageEnum.RestAPIResponceMessage)
    ]);
  }

  // async receive(from: string, message: Message) {
  //   if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
  
  //     const apiRequestCallId = message.getData(
  //       getName(MessageEnum.RestAPIResponceDataMessage)
  //     );
  
  //     const responseJson = message.getData(
  //       getName(MessageEnum.RestAPIResponceSuccessMessage)
  //     );
  
  //     if (apiRequestCallId === this.getStudyApiCallId) {

  //       const study = responseJson?.data;
      
  //       const currentStudyId = localStorage.getItem("studyId");
      
  //       const selectedStudy =
  //         study?.id === String(currentStudyId)
  //           ? study
  //           : null;
      
  //       const communityEnabled =
  //         selectedStudy?.attributes?.community === true ||
  //         selectedStudy?.attributes?.study_preferences?.community === true;
      
  //       localStorage.setItem(
  //         "communityEnabled",
  //         String(communityEnabled)
  //       );
      
  //       this.setState({
  //         isCommunityEnabled: communityEnabled,
  //       });
  //     }
  //   }
  // }
async receive(from: string, message: Message) {
  if (getName(MessageEnum.RestAPIResponceMessage) !== message.id) {
    return;
  }

  const apiRequestCallId = message.getData(
    getName(MessageEnum.RestAPIResponceDataMessage)
  );

  const responseJson = message.getData(
    getName(MessageEnum.RestAPIResponceSuccessMessage)
  );

  const study = responseJson?.data;
  if (!study || study?.type !== "study") {
    return;
  }
  const currentStudyId = localStorage.getItem("studyId");
  if (String(study?.id) !== String(currentStudyId)) {
    console.log("⚠️ Study ID does not match current study");
    return;
  }

  const communityEnabled =
    study?.attributes?.community === true ||
    study?.attributes?.study_preferences?.community === true;

  console.log("🔥 STUDY:", study);
  console.log("🔥🔥 COMMUNITY ENABLED:", communityEnabled);

  localStorage.setItem(
    "communityEnabled",
    String(communityEnabled)
  );

  this.setState({
    isCommunityEnabled: communityEnabled
  });
}
  // componentDidMount = async () => {
  //   this.connectQuickBloxServer(this.QB)
  //   this.QB.webrtc.onCallListener = this.handleCallListner
  //   window.addEventListener("studyChanged", this.getStudyDetails);
  //   this.setState({selected: this.props.selected || "dashboard"})
  //   this.getStudyDetails();
  // }

  componentDidMount = async () => {
    console.log("🔥🔥🔥 SIDEBAR MOUNTED");
  
    window.addEventListener("studyChanged", this.getStudyDetails);
  
    console.log("🔥 ABOUT TO CALL getStudyDetails");
  
    this.getStudyDetails();
  
    console.log("🔥 AFTER getStudyDetails");
  
    this.connectQuickBloxServer(this.QB);
    this.QB.webrtc.onCallListener = this.handleCallListner;
  
    this.setState({
      selected: this.props.selected || "dashboard"
    });
  };
  async componentWillUnmount(): Promise<void> {
    window.removeEventListener("studyChanged", this.getStudyDetails);
  }

  handleCallListner = (session: any, extension: any) => {
    const userID = localStorage.getItem('userId')
    let user;
    const users = [session.currentUserID, session.initiatorID].filter((i: any) => {
      if(String(i) !== userID) {
        user = i
      }
    })

    this.setState({ isCalling: true, userDetail: extension, userIdDialog: user, sessionState: session })
  };

  handleCallRejectListner = (session: QBWebRTCSession, userId: QBUser['id'], extension: Record<string, any>) => { 
    session.reject(extension)
   };

   handleCallReject = () => {
    this.setState({ isCalling: false});

    this.state.sessionState.reject({})
   }
   
  connectQuickBloxServer = async (QB:any) => {
    const storedCredentialsString: string | null | any = localStorage.getItem('quickBloxCredentials');
    const storedCredentials = JSON.parse(storedCredentialsString);
  
    const CONFIG = {
      // other settings
      webrtc: {
        disconnectTimeInterval: 86400,
      }
      // other settings
    };
  
    QB.init(storedCredentials?.appId, storedCredentials?.authKey, storedCredentials?.authSecret, storedCredentials?.accountKey, CONFIG);
  
    const userUniqnueId: any = localStorage.getItem("userUniqnueId");
    const userPassword = "Password@123";
  
    const paramsLogin = {
      login: userUniqnueId,
      password: userPassword,
    };
    QB.createSession(paramsLogin, async (error: any, result: any) => {
  
      localStorage.setItem("userId", result.user_id);
      localStorage.setItem("chatToken", result.token);
  
      QB.login(paramsLogin, (error: any, result: any) => {})
      const Login = {
        userId: result.user_id,
        password: userPassword,
      };
  
      QB.chat.connect(Login, (err: any, result: any) => {
        this.getListOfDialog()
      })
    });
  };

  getStudyDetails = () => {
    console.log("🔥🔥🔥 GET STUDY DETAILS CALLED");
  
    const token = localStorage.getItem("token");
  
    console.log("🔥 TOKEN:", token);
  
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
  
    console.log("🔥 REQUEST MESSAGE ID:", requestMessage.messageId);
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({
        "Content-Type": configJSON.apiContentType,
        token: token
      })
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getStudyApiEndPoint
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getApiMethod
    );
  
    this.getStudyApiCallId = requestMessage.messageId;
  
    console.log(
      "🔥🔥🔥 SAVED SIDEBAR REQUEST ID:",
      this.getStudyApiCallId
    );
  
    runEngine.sendMessage(
      requestMessage.id,
      requestMessage
    );
  
    console.log("🔥🔥🔥 REQUEST SENT");
  };

  handleNavigate = () => {
    localStorage.setItem("Iscalling", 'true')
    const user = this.state.usersChatList.find((obj: any) => obj.user_id == this.state.userIdDialog)

    localStorage.setItem("userDialog", JSON.stringify(user))
    const message = new Message(getName(MessageEnum.NavigationMessage));
    message.addData(getName(MessageEnum.NavigationTargetMessage),'Chat');
    message.addData(getName(MessageEnum.NavigationPropsMessage),this.props);
    this.send(message);
  }

  getListOfDialog = () => {
    const params = {
      limit: 100,
    };
  
    this.QB.chat.dialog?.list(params, (error: any, dialogs: any) => {
      if (dialogs) {
        const patientData: any = JSON.parse(localStorage.getItem('patientData') || '[]');
        const ids: any[] = [];
        const mainData = dialogs.items.map((dialog: any) => {
          ids.push(dialog.user_id);
          const matchingPatient = patientData.find((patient: any) =>
            dialog.occupants_ids.includes(patient.user_data.quickblox_id)
          );
  
          if (matchingPatient) {
            return {
              ...dialog,
              full_name: matchingPatient.user_data.full_name,
            };
          }
          return dialog;
          })
          .filter((dialog: any) => dialog !== null)
        this.setState({ usersChatList: mainData,patientsIds: ids });
      }
    });
  };

  selectTab = (key: TabValue) => {
    if (this.state.selected === key) return;
    this.setState({ selected: key }, () => {

    switch (key) {
      case "dashboard": {
        return this.props.navigation.navigate("Dashboard");
      }
      case "patient": {
        return this.props.navigation.navigate("Patient");
      }
      case "visit_schedule": {
        this.props.navigation.navigate("Appointments");
        return;
      }
      case "task_list": {
        this.props.navigation.navigate("TaskList");
        return;
      }
      case "send_notification": {
        this.props.navigation.navigate("Pushnotifications");
        return;
      }
      case "messages": {
        this.props.navigation.navigate("Chat");
        return;
      }
      case "community": {
        this.props.navigation.navigate("Chat");
        return;
      }

      default: {
        return this.openModal();
      }
    }
  });
};

  openModal = () => {
    this.setState({showModal: true})
  }

  closeModal = () => {
    this.setState({showModal: false})
  }

  getQuickBloxCredentials() {
    let storedCredentials = JSON.parse(configJSON.credsForQB);
    return {
      appId: storedCredentials.appId,
      authKey: storedCredentials.authKey,
      authSecret: storedCredentials.authSecret,
      accountKey: storedCredentials.accountKey,
    };
  }
}

export default SidebarController;
